import React from 'react'

function Cooking() {
  return (
    <>
      <h1> Cooking is actually something I love doing, I know its very rare for guys. </h1>
    </>
  )
}

export default Cooking